<template>
  <v-card>
    <v-card-title class="text-center">お申し込みフォーム</v-card-title>
    <v-divider />
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-item key="step-1-header" value="1" />
        <v-stepper-item key="step-2-header" value="2" />
        <v-stepper-item key="step-3-header" value="3" />
      </v-stepper-header>
      <v-stepper-window>
        <v-stepper-window-item key="step-1-content" value="1">
          <v-form ref="form1">
            <v-row class="align-end d-none">
              <v-col cols="12">
                <v-label for="term">
                  <v-input v-model="imrobot" type="checkbox" name="term" required />
                  わたしはロボットです
                  ※もしあなたがロボットではない場合は✓を入れてはいけません
                </v-label>
              </v-col>
            </v-row>
            <v-row class="name align-end">
              <v-col cols="6">
                <v-label text="氏名" />
                <v-text-field name="lastname" v-model="model.lastname" :rules="[
                  isRequired('氏名（姓）'),
                ]" label="（姓）" placeholder="田中" variant="outlined" density="compact" required />
              </v-col>

              <v-col cols="6">
                <v-text-field name="firstname" v-model="model.firstname" :rules="[
                  isRequired('氏名（名）'),
                ]" label="（名）" placeholder="太郎" variant="outlined" density="compact" required />
              </v-col>
            </v-row>
            <v-row class="align-end">
              <v-col cols="12" md="12">
                <v-label text="メールアドレス" />
                <v-text-field name="email" v-model="model.email" :rules="[
                  isRequired('メールアドレス'),
                  isSutisfiedWithFormat('メールアドレス', emailFormatRegex),
                ]" placeholder="info@example.com" variant="outlined" density="compact" required />
              </v-col>
              <v-col cols="12" md="12">
                <v-label text="メールアドレス（確認用）" />
                <v-text-field v-model="emailVerify" :rules="[
                  isRequired('メールアドレス（確認用）'),
                  isSutisfiedWithFormat('メールアドレス（確認用）', emailFormatRegex),
                  isEqualledWithItem('メールアドレス（確認用）', model.email, 'メールアドレス'),
                ]" placeholder="info@example.com" variant="outlined" density="compact" required />
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-window-item>
        <v-stepper-window-item key="step-2-content" value="2">
          <span>アンケート（1/2）</span>
          <p style="font-size:0.75rem;">当日お話しする内容の参考のため、ご協力をお願いします。</p>
          <v-form ref="form2">
            <v-row class="align-end">
              <v-col cols="12">
                <v-label style="font-size:0.75rem;" text="法律の学習経験または法務実務経験" />
                <v-checkbox class="no_error_message" density="compact" v-for="experienceItem in Object.values(experienceItems)"
                  :label="experienceItem.label" :value="experienceItem.value" v-model="model.learnedLegalType" />
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-window-item>
        <v-stepper-window-item key="step-3-content" value="3">
          <span>アンケート（2/2）</span>
          <p style="font-size:0.75rem;">当日お話しする内容の参考のため、ご協力をお願いします。</p>
          <v-form ref="form3" method="post" action="/seminar/202506/thanks">
            <v-row class="align-end">
              <v-col cols="12">
                <v-label style="font-size:0.75rem;" text="ご年齢" />
                <v-select class="no_error_message" v-model="model.era" density="compact" item-title="label" item-value="value"
                  :items="Object.values(eraItems)" />
              </v-col>
            </v-row>
            <v-row class="align-end">
              <v-col cols="12">
                <v-label style="font-size:0.75rem;" text="セミナーでお聞きしたいことをご記入ください" />
                <v-textarea name="q_and_a" v-model="model.q_and_a" variant="outlined" density="compact" required />
              </v-col>
            </v-row>
            <v-row class="align-end">
              <v-col class="pa-0">
                <v-checkbox class="privacy-policy" v-model="ppagreement" :rules="[isRequired('個人情報への同意', 'checkbox', '<<label>>が必要です。')]"
                  density="compact" required>
                  <template v-slot:label>
                    <div>
                      <client-only>
                        <v-tooltip location="bottom">
                          <template v-slot:activator="{ props }">
                            <a href="https://legal-agent.jp/privacypolicy/" target="_blank" v-bind="props" @click.stop>
                              個人情報の取り扱い
                            </a>
                          </template>
                          Opens in new window
                        </v-tooltip>
                      </client-only>
                      に同意します。
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-window-item>
      </v-stepper-window>
      <v-divider />
      <div class="d-flex ma-3">
        <v-btn class="mr-auto" size="large" v-if="step > 0" @click="prevHandler">前へ</v-btn>
        <v-btn class="ml-auto" color="primary" size="large" @click="nextHandler">
          {{ step < steps.length - 1 ? '次へ' : '申し込む' }} </v-btn>
      </div>
      <v-overlay persistent class="align-center justify-center" :no-click-animation="true" v-model="overlay" contained>
        <v-progress-circular color="primary" indeterminate />
        <p>処理中です</p>
      </v-overlay>
      <v-overlay v-if="isMounted" persistent class="align-center justify-center" :no-click-animation="true" v-model="isExpiredApply" contained>
        <p style="opacity:1;font-weight:700;">このセミナーの参加受付は終了しました</p>
      </v-overlay>
    </v-stepper>
  </v-card>
</template>

<style lang="scss">
.grecaptcha-badge {
  visibility: hidden;
}
</style>

<style lang="scss">
.v-card {
  & .v-overlay {
    & .v-overlay__content {
      text-align: center;
    }
  }

  & .v-sheet {
    & .v-stepper-header {
      & .v-stepper-item {
        padding: 0.75rem;
      }
    }

    & .v-window {
      margin: 0.5rem;

      & .v-form {
        & .v-row {
          margin: 0;

          & [class^="v-col"] {
            padding: 0.25rem;

            & .v-input {
              line-height: 1;

              &.v-input--plain-underlined .v-field .v-field__field {
                & label {
                  display: block;
                }
              }

              &.v-checkbox.no_error_message,
              &.v-checkbox.privacy-policy:not(:has(.v-selection-control--error)),
              &.v-select.no_error_message {
                & .v-input__details {
                  display: none;
                }
              }

              & .v-input__details {
                padding: 0 !important;
                font-size: 0.3rem;
              }

              &[name=term] {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<script setup lang="ts">
import { ref } from 'vue';
import { isRequired, isSutisfiedWithFormat, isEqualledWithItem, emailFormatRegex } from '@/libs/validation';
import { experienceItems, eraItems } from '@/assets/hubspot/seminar_form';
interface Props {
  isExpiredApply: boolean;
}

const props = defineProps<Props>();
const isExpiredApply = ref(props.isExpiredApply);
const isMounted = ref(false);

onMounted(() => {
  isMounted.value = true;
});

const runtimeConfig = useRuntimeConfig();
useHead({
  script: [
    {
      key: 'load-grecapcha-script',
      src: `https://www.google.com/recaptcha/api.js?render=${runtimeConfig.public.googleRecapchaSiteKey!}`,
      async: true,
      defer: true,
    },
  ],
});
interface Model {
  lastname?: string;
  firstname?: string;
  email?: string;
  learnedLegalType?: number[] | null;
  era?: number | null;
  q_and_a?: string | null;
}

const step: Ref<number> = ref(0);

const model: Ref<Model> = ref({
  learnedLegalType: [],
});

const form1 = ref();
const form2 = ref();
const form3 = ref();
const steps = [
  {
    form: form1,
  },
  {
    form: form2,
  },
  {
    form: form3,
  },
];

// スパムトラップ
// URL : https://zenn.dev/coedo/articles/spam-free-mail-form
const imrobot = ref(false);
const ppagreement = ref(false);
const emailVerify = ref('');
const overlay = ref(false);


const nextHandler = (async () => {
  if (import.meta.client) {
    if (!imrobot.value) {
      const form = steps[step.value].form;
      const { valid } = await form.value.validate();
      try {
        if (valid) {
          if (step.value === steps.length - 1) {
            overlay.value = true;
            // grecaptcha が読み込まれているか確認
            //@ts-ignore grecaptchaが読み込まれているかの確認
            if (!window.grecaptcha) {
              throw new Error('reCAPTCHA is not loaded')
            }

            // トークンを取得（アクション名は自由につけてOK）
            //@ts-ignore grecaptchaが読み込まれているかの確認
            const recaptchaToken = await window.grecaptcha.execute(runtimeConfig.public.googleRecapchaSiteKey, {
              action: 'submit'
            });

            const { data, status, error } = await useFetch(`/api/form/e76b7703-3af9-482f-b209-11d09cfd9b19`, {
              method: 'POST',
              body: {
                ...model.value,
                recaptchaToken: recaptchaToken,
                pageUrl: useRequestURL().toString(),
                pageTitle: document.title,
                seminarDatetime: `2025年6月19日（木）　19:00 ～`,
                mailTemplate: 'attorneys_academy_seminar_thanks_with_url',
                seminarDetailUrl: `${runtimeConfig.public.appUrlOrigin}/seminar/202506`,
                webinarUrl: "https://us02web.zoom.us/j/84549098997",
              },
            });
            if (status.value !== "success") {
              overlay.value = false;
            } else {
              form.value.submit();
            }
          } else {
            step.value++;
          }
        }
      } catch (error) {
        throw error;
      }
    }
  }
});
const prevHandler = (async () => {
  step.value--;
});
</script>